export default "__VITE_ASSET__CbAiyi9v__"